import React, { useEffect } from 'react';

import { useUserAuthUnsafe } from './UserAuthProvider';

// Exports
type Props = { fallback?: React.ReactNode };
/** Rendering this component will immediately log the user out */
export const Logout = ({ fallback = null }: Props) => {
  const { logout } = useUserAuthUnsafe();
  useEffect(() => {
    (async () => {
      await logout();
    })();
  }, [logout]);

  return <>{fallback}</>;
};
